import { cloneDeep } from 'lodash';
const uuid = require('uuid');

import GameData from './gamedata.js';
import Partutil from './partutil.js';

function ToyData(layers, toydata, convert) {
  console.log('have layers?!?!?!?!', layers);
  toydata.variables = [];
  toydata.toybox = [];
  toydata.features = [];
  toydata.scenes = [];
  this.toydata = toydata;
  this.toydata.layers = layers;
  this.convert = convert;
  this.gamedata = new GameData(toydata, convert);
}

ToyData.prototype.getTransformsAndSource = function () {
  return {
    from:this.toydata,
    transforms:this.toydata.transforms,
    gamedata:this.gamedata,
    source:'toy',
    root:{id:'root'}
  }
}

ToyData.prototype.clone = function () {

  const newToyData = cloneDeep(this.toydata);
  const newComponentMapping = {};
  const newLinkMapping = {};

  newToyData.components.forEach( (c) => {
    const id = c.id;
    if (!newComponentMapping[id]) {
      newComponentMapping[id] = uuid.v4();
    }
  });

  newToyData.links.forEach( (link) => {
    const id = link.id;
    if (!newLinkMapping[id]) {
      newLinkMapping[id] = uuid.v4();
    }
  });

  const toydata2 = new ToyData(this.toydata.layers, newToyData, this.convert);

  const partutil = new Partutil(toydata2.getTransformsAndSource());
  partutil.findAllChildren().forEach( (transform) => {
    console.log('do transform', transform.id);
    transform.id = uuid.v4();
    transform.cid = newComponentMapping[transform.cid];
  });


  newToyData.components.forEach( (c) => {
    c.id = newComponentMapping[c.id];
  });

  newToyData.links.forEach( (link) => {
    const {id,source,target} = link;
    link.id = newLinkMapping[id];
    link.source = newComponentMapping[source];
    link.target = newComponentMapping[target];
  });


  return newToyData;

}

export default ToyData;
